import template from './importFields.template.html';

export default {
  template,
  bindings: {
    isOnPdfFillRoute: '<',
    mergeFields: '<',
    importFiled: '=',
    binding: '<',
    mappableFields: '=',
    workflowType: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($timeout, $filter, $mdMedia, $mdMenu) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.isMenuVisible = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.binding = ctrl.binding;
        ctrl.firstLevel = true;
        ctrl.isMenuVisible = false;
        ctrl.searchTerm = '';
        ctrl.mergeProperties = $filter('orderBy')(ctrl.mergeFields, 'weight');
      };

      ctrl.back = function ($event) {
        $event.stopPropagation();

        ctrl.firstLevel = true;
        ctrl.mergeProperties = $filter('orderBy')(ctrl.mergeFields, 'weight');
      };

      ctrl.close = function ($event) {
        if ($event) {
          $event.stopPropagation();
        }
        this.initialize();
        $mdMenu.destroy();
      };

      ctrl.openSubMenu = function (property) {
        ctrl.firstLevel = false;
        ctrl.searchTerm = '';
        ctrl.mergeProperties = $filter('orderBy')(property.value, 'weight');
      };

      ctrl.addPropertyCode = function (binding, property) {
        ctrl.onFinished({
          binding: ctrl.binding,
          property: property,
          importFiled: ctrl.importFiled
        });
        $timeout(function () {
          ctrl.close();
        });
      };

      ctrl.isAddedField = function (binding) {
        if (binding !== null) {
          var b = parseInt(binding.replace('property', ''));
          var f = _.find(ctrl.mappableFields, function (item) {
            return item.id === b;
          });
          return f !== undefined;
        }
      };

      ctrl.isAddedProperty = function (property) {
        var p = undefined;
        var nName = null;
        if (
          ctrl.getFieldShortName(property.name, 0) === 'Person 1' ||
          ctrl.getFieldShortName(property.name, 0) === 'Person 2' ||
          ctrl.getFieldShortName(property.name, 0) === 'Person 3' ||
          ctrl.getFieldShortName(property.name, 0) === 'Person 4' ||
          ctrl.getFieldShortName(property.name, 0) === 'Person 5'
        ) {
          nName = ctrl.getFieldShortName(property.name, 0).replace(/[^0-9]/g, '');
        }
        if (nName !== null) {
          p = _.find(ctrl.mappableFields, function (item) {
            return (
              ctrl.getFieldShortName(item.name, 0) === 'Person ' + nName &&
              item.mappableKey === property.key
            );
          });
        } else {
          p = _.find(ctrl.mappableFields, function (item) {
            return item.mappableKey === property.key;
          });
        }
        return p !== undefined;
      };

      ctrl.showMenu = function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        ctrl.isMenuVisible = true;
        $timeout(function () {
          angular.element('md-menu.mappable-button .md-button').triggerHandler('click');
        });
      };

      ctrl.selectedWorkflowType = function (property) {
        return !property.workflowType || property.workflowType === null
          ? true
          : property.workflowType.indexOf(ctrl.workflowType) !== -1;
      };

      ctrl.getFieldShortName = function (name, index) {
        var _name = name.split(' - ');
        return _name[index] !== '' ? _name[index] : _name[index - 1];
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        this.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {};
    }
  }
};
